import { apiConnections, type EnvConfig, websocketConnections } from './environment';
import { normalizeUrl } from './utilities';

// Shallow clone to fix issues with empty values
const env = Object.assign({}, process.env);

const config: EnvConfig = {
    apiConnections,
    authProviders: {
        apple: !!parseInt(env.REACT_APP_AUTH_PROVIDER_APPLE || '0'),
        discord: !!parseInt(env.REACT_APP_AUTH_PROVIDER_DISCORD || '0'),
        google: !!parseInt(env.REACT_APP_AUTH_PROVIDER_GOOGLE || '0'),
        twitter: !!parseInt(env.REACT_APP_AUTH_PROVIDER_TWITTER || '0'),
    },
    websocketConnections,
    nodeEnv: env.NODE_ENV || 'development',
    publicUrl: normalizeUrl(env.REACT_APP_PUBLIC_URL || window.location.href).host,
    mediaMasherUrl: env.REACT_APP_MEDIA_MASHER_URL || 'https://m.y.at',
    apiTimeout: parseInt(env.REACT_APP_API_TIMEOUT || '30000'),
    yatDomain: env.REACT_APP_YAT_DOMAIN || 'y.at',
    apiUrl: env.REACT_APP_API_URL || 'https://y.at/a',
    nbeApiUrl: env.REACT_APP_API_URL_NBE || 'https://y.at/nbe',
    wsApiUrl: env.REACT_APP_API_URL_WS || 'wss://y.at/a',
    daasApiUrl: env.REACT_APP_API_URL_DAAS || 'https://y.y.at/websocket',
    daasV2ApiUrl: env.REACT_APP_API_URL_DAASV2 || 'https://daas.y.at/v2',
    daasQqlApiUrl: env.REACT_APP_API_URL_DAASGQL || 'https://daas-gql.yat.fyi/api/rest',
    gsApiUrl: env.REACT_APP_API_URL_GS || 'https://y.at/s',
    authApiUrl: env.REACT_APP_API_URL_AUTH || 'https://micro.yat.fyi/s',
    gqlApiUrl: env.REACT_APP_API_URL_GQL || 'http://yat.docker.localhost/gql',
    wsYacsApiUrl: env.REACT_APP_API_URL_WS_YACS || 'wss://y.y.at',
    wsYacsApiPathname: env.REACT_APP_API_URL_WS_PATHNAME || '/websocket',
    referralCodeUrl: '❤️🔥💡.y.at',
    stripeKey: env.REACT_APP_STRIPE_KEY || '',
    maxLengthYat: parseInt(env.REACT_APP_MAX_LENGTH_YAT || '6'),
    minLengthYatForSale: parseInt(env.REACT_APP_MIN_LENGTH_YAT_FOR_SALE || '3'),
    maxLengthYatForSale: parseInt(env.REACT_APP_MAX_LENGTH_YAT_FOR_SALE || '5'),
    segmentApiKey: env.REACT_APP_SEGMENT_API_KEY || '',
    analytics: {
        searchLengthMin: parseInt(env.REACT_APP_ANALYTICS_SEARCH_LENGTH_MIN || '3'),
        searchLengthMax: parseInt(env.REACT_APP_ANALYTICS_SEARCH_LENGTH_MAX || '5'),
    },
    fbPixelId: env.REACT_APP_PIXEL_ID,
    redditPixelId: env.REACT_APP_REDDIT_PIXEL_ID,
    redirectRoot: env.REACT_APP_REDIRECT_ROOT || '',
    linkItemMaxLength: parseInt(env.REACT_APP_LINK_ITEM_MAX_LENGTH || '1024'),
    supportLink: env.REACT_APP_SUPPORT_LINK || 'https://support.y.at/',
    salesEmail: env.REACT_APP_SALES_EMAIL || 'sales@y.at',
    termsLink: env.REACT_APP_TERMS_LINK || '/terms',
    licenseLink: env.REACT_APP_LICENSE_LINK || 'https://legal.y.at/license',
    privacyLink: env.REACT_APP_PRIVACY_LINK || '/privacy-policy',
    requestEmojiLink: env.REACT_APP_REQUEST_EMOJI_LINK || 'https://yativerse.y.at/yat-request',
    featureFlags: {
        clearCartButton: !!parseInt(env.REACT_APP_FF_CLEAR_CART_BUTTON || '0'),
        enableCurrencySelector: !!parseInt(env.REACT_APP_FF_ENABLE_CURRENCY_SELECTOR || '0'),
        enablePetraWallet: !!parseInt(env.REACT_APP_FF_ENABLE_PETRA_WALLET || '0'),
        enableWebsockets: !!parseInt(env.REACT_APP_FF_ENABLE_WEBSOCKETS || '0'),
        enableYatRemint: !!parseInt(env.REACT_APP_FF_ENABLE_YAT_REMINT || '0'),
        forcePasswords: !!parseInt(env.REACT_APP_FF_FORCE_PASSWORDS || '0'),
        isWalletManagerEnabled: !!parseInt(env.REACT_APP_FF_IS_WALLET_MANAGER_ENABLED || '0'),
        tnyLedgerConnectEnabled: !!parseInt(env.REACT_APP_FF_IS_TNY_LEDGER_CONNECT_ENABLED || '0'),
        showAdminInfo: !!parseInt(env.REACT_APP_FF_SHOW_ADMIN_INFO || '0'),
        show2FAPrompts: !!parseInt(env.REACT_APP_FF_SHOW_2FA_PROMPTS || '0'),
        showArtifactSync: !!parseInt(env.REACT_APP_FF_SHOW_ARTIFACT_SYNC || '0'),
        showConvertYatPage: !!parseInt(env.REACT_APP_FF_SHOW_CONVERT_YAT_PAGE || '0'),
        showNftMintFlow: !!parseInt(env.REACT_APP_FF_SHOW_NFT_MINT_FLOW || '0'),
        showInviteToYat: !!parseInt(env.REACT_APP_FF_SHOW_INVITE_TO_YAT || '0'),
        useSpriteForEmojis: !!parseInt(env.REACT_APP_FF_USE_SPRITE_FOR_EMOJIS || '0'),
        yatInUrl: !!parseInt(env.REACT_APP_FF_YAT_IN_URL || '0'),
        yatPageLinkTracking: !!parseInt(env.REACT_APP_FF_YAT_PAGE_LINK_TRACKING || '0'),
        yatsPortfolio: !!parseInt(env.REACT_APP_FF_YATS_PORTFOLIO || '0'),
        enableTwitterConnectFlow: !!parseInt(env.REACT_APP_FF_ENABLE_TWITTER_CONNECT_FLOW || '0'),
        showGainsAndLosses: !!parseInt(env.REACT_APP_FF_SHOW_GAINS_LOSS || '0'),
        newAuthEnabled: !!parseInt(env.REACT_APP_FF_NEW_AUTH_ENABLED || '0'),
        marketplaceV1Enabled: !!parseInt(env.REACT_APP_FF_MARKETPLACE_V1 || '0'),
        marketplaceNextEnabled: !!parseInt(env.REACT_APP_FF_MARKETPLACE_NEXT || '0'),
        showActivityFeeds: !!parseInt(env.REACT_APP_FF_ACTIVITY_FEEDS || '0'),
        showFantasyInvites: !!parseInt(env.REACT_APP_FF_FANTASY_INVITES || '0'),
        showFantasyAudits: !!parseInt(env.REACT_APP_FF_FANTASY_AUDITS || '0'),
        showDiscoverPage: !!parseInt(env.REACT_APP_FF_DISCOVER_PAGE || '0'),
        yatFantasyEnabled: !!parseInt(env.REACT_APP_FF_YAT_FANTASY_ENABLED || '0'),
        showLegacyYativerse: !!parseInt(env.REACT_APP_FF_SHOW_LEGACY_YATIVERSE || '1'),
        showLegacyLiquidID: !!parseInt(env.REACT_APP_FF_SHOW_LEGACY_LIQUIDID || '0'),
        showCSSLiquidID: !!parseInt(env.REACT_APP_FF_SHOW_CSS_LIQUIDID || '0'),
        showCoinPayments: !!parseInt(env.REACT_APP_FF_SHOW_COINPAYMENTS || '0'),
    },
    coinpaymentsMerchantId: env.REACT_APP_COINPAYMENTS_MERCHANT_ID || '',
    longerYatDisplayLength: parseInt(env.REACT_APP_LONGER_YAT_DISPLAY_LENGTH || '4'),
    openPrismCaseVideoUrlPrefix: env.REACT_APP_OPEN_PRISM_CASE_VIDEO_URL_PREFIX || 'https://y.at/prismcases',
    openPrismKeyVideoUrlPrefix: env.REACT_APP_OPEN_PRISM_KEY_VIDEO_URL_PREFIX || 'https://y.at/prismkeys',
    jobsLink: env.REACT_APP_JOBS_LINK || 'https://emojis.y.at/careers',
    imageUrl: env.REACT_APP_IMAGE_URL || 'https://i.y.at',
    cartLimit: parseInt(env.REACT_APP_CART_LIMIT || '30'),
    wsMaxBackOff: parseInt(env.REACT_APP_WS_MAX_BACK_OFF || '32'),
    transferCodeDigitCount: parseInt(env.REACT_APP_TRANSFER_CODE_DIGIT_COUNT || '4'),
    twoFACodeDigitCount: parseInt(env.REACT_APP_2FA_CODE_DIGIT_COUNT || '6'),
    twoFAWallEnabled: !!parseInt(env.REACT_APP_2FA_WALL_ENABLED || '0'),
    homeUrl: env.REACT_APP_HOME_URL || '/home',
    passwordDeployDate: env.REACT_APP_PASSWORD_DEPLOY_DATE || '',
    allowYatImageSwapDate: env.REACT_APP_ALLOW_YAT_IMAGE_SWAP_DATE
        ? new Date(env.REACT_APP_ALLOW_YAT_IMAGE_SWAP_DATE)
        : new Date(),
    delayBetween2FAPrompts: parseFloat(env.REACT_APP_DELAY_BETWEEN_2FA_PROMPTS || '7'),
    tokenContractAddress: env.REACT_APP_TOKEN_CONTRACT_ADDRESS || '0x7d256d82b32d8003d1cA1a1526ED211E6e0dA9e2',
    gemContractAddress: env.REACT_APP_GEM_CONTRACT_ADDRESS || '0xfa9A63060624E10328149fCb8D19D88d8B6f0E31',
    nftSignatureEndpoint: env.REACT_APP_NFT_SIGN_ENDPOINT || 'http://54.236.35.123:18080/sign',
    nftOpenseaLink: env.REACT_APP_NFT_OPENSEA_LINK || 'https://testnets.opensea.io/assets',
    visualizerLink: env.REACT_APP_LINK_VISUALIZER || 'https://y.at/viz-editor/',
    yatGen1Start: new Date(env.REACT_APP_GEN_1_START || '1970-01-01T00:00:00Z'),
    yatGen2Start: new Date(env.REACT_APP_GEN_2_START || '2024-03-31T23:09:30.0Z'),
    disclosureLink: env.REACT_APP_LINK_DISCLOSURE || 'https://legal.y.at/disclosure',
    syncSupportLink:
        env.REACT_APP_LINK_SYNC_SUPPORT ||
        'https://support.y.at/hc/en-us/articles/6335922511387-How-Do-I-Add-Yats-Acquired-on-Opensea-Into-My-Yat-Account-',
    yativerseLink: 'https://yativerse.y.at',
    everflowTrackingDomain: env.REACT_APP_EVERFLOW_TRACKING_DOMAIN || 'https://www.y03btrk.com',
    artifactsVideos: {
        twitter: {
            celestialRose: env.REACT_APP_TWITTER_VIDEO_CELESTIAL_ROSE || 'pic.twitter.com/tiX33KndjC',
            cloudSeed: env.REACT_APP_TWITTER_VIDEO_CLOUD_SEED || 'pic.twitter.com/qRkZpqGJmC',
            prismCase: env.REACT_APP_TWITTER_VIDEO_PRISM_CASE || 'pic.twitter.com/qPmcKdpwzq',
            prismKey: env.REACT_APP_TWITTER_VIDEO_PRISM_KEY || 'pic.twitter.com/MiGYBucDIA',
        },
    },
    newYatDemoLink: env.REACT_APP_NEW_YAT_DEMO_LINK || 'https://demo-newyat.scratch.emojid.me/admin/sign-in',
    socialMedia: {
        discord: 'https://discord.gg/yat',
        twitter: 'https://twitter.com/whatsyouryat',
        tiktok: 'https://www.tiktok.com/@whatsyouryat',
        instagram: 'https://www.instagram.com/whatsyouryat/',
    },
    wsRefreshDelay: parseInt(env.REACT_APP_WS_REFRESH_DELAY || '6000'),
    nftBlackListedDomains: env.REACT_APP_BLACKLISTED_NFT_DOMAINS?.split(',') || [],
    audioExtensions: ['mp3', 'ogg', 'm4a', 'wav', 'flac', 'wma', 'aac'].concat(
        env.REACT_APP_AUDIO_EXTENSIONS?.split(',') || [],
    ),
    cdnAssetsUrl: env.REACT_APP_CDN_ASSETS_URL || 'https://y.at/assets',
    useMockServer: !!parseInt(env.REACT_APP_USE_MOCK_SERVER || '0'),
    ignoreSegmentHeaders: env.REACT_APP_IGNORE_SEGMENT_HEADERS || '',
    fantasyAlphaUrl: env.REACT_APP_API_URL_FANTASY || '',
    walletConnectProjectId: env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'a8c1f7404ea9378b29bed916fc62b731',
};

export default config;
